import { Navigate } from 'react-router-dom';
import { ReactNode } from 'react';
import { User } from '../types/models';

interface PublicRouteProps {
  children: ReactNode;
}

export const PublicRoute = ({ children }: PublicRouteProps) => {
  const token = localStorage.getItem('auth_token');

  if (token) {
    // Check user role to redirect to appropriate dashboard
    const userStr = localStorage.getItem('user');
    if (userStr) {
      const user: User = JSON.parse(userStr);
      const userRoles = user?.roles?.map(r => r.name) || [];

      if (userRoles.includes('Super Admin')) {
        return <Navigate to="/superadmin/dashboard" replace />;
      }
    }

    return <Navigate to="/dashboard" replace />;
  }

  return <>{children}</>;
};
